import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';

const taskPointList = [
    {
        img: '/images/svg/mid/magnit.svg',
        title: 'Привлечение',
        text: 'Подогреть интерес на&nbsp;поступление при помощи привлечения на&nbsp;дни открытых дверей выпускников 9&nbsp;и&nbsp;11&nbsp;классов, людей с&nbsp;неоконченным высшим, неоконченным средним профессиональным и&nbsp;высшим образованием, а&nbsp;также информирования родителей и&nbsp;учителей школьников',
    },
    {
        img: '/images/svg/mid/anketa.svg',
        title: 'Сбор анкет',
        text: 'Обеспечить сбор не&nbsp;менее 500 анкет для каждого потока на&nbsp;поступление в&nbsp;Колледж МИД',
    },
];

const Tasks = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="mid-tasks">
                <div className="mid-tasks__wrapper">
                    <div className="mid-tasks__grid">
                        <div className="mid-tasks__info">
                            <CommonTitle className="mid-tasks__title">Задачи</CommonTitle>
                            <CommonUsualText className="mid-tasks__subtitle">
                                С&nbsp;2018 года мы&nbsp;помогаем Колледжу МИД информировать
                                выпускников 9&nbsp;и&nbsp;11&nbsp;классов, их&nbsp;родителей
                                и&nbsp;учителей о&nbsp;программах обучения, возможностях
                                трудоустройства и&nbsp;карьерного роста в&nbsp;главных
                                государственных и&nbsp;коммерческих структурах России
                                и&nbsp;зарубежья.
                            </CommonUsualText>
                        </div>
                        <div className="mid-tasks__points">
                            {taskPointList.map(({ img, title, text }, index) => (
                                <ScrollAnimation
                                    animateIn="fadeIn"
                                    offset={50}
                                    animateOnce={true}
                                    duration={1}
                                    className="mid-tasks__point-item"
                                    key={index}
                                >
                                    <div className="mid-tasks__point-title">
                                        <img
                                            className="mid-tasks__point-img"
                                            src={img}
                                            alt=""
                                            loading="lazy"
                                        />
                                        <CommonSmallTitle>{parse(title)}</CommonSmallTitle>
                                    </div>
                                    <CommonSmallText className="mid-tasks__point-text">
                                        {parse(text)}
                                    </CommonSmallText>
                                </ScrollAnimation>
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Tasks;
